<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <tabs v-model="activeTab" @input="changeTab" class="empty-tab">
        <tab
          :key="`tab-${index}`"
          v-for="(tab, index) of authorizedTabs"
          :header="tab.label"
        >
        </tab>
      </tabs>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },

  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Dépenses",
          name: "expense",
          requiredPermission: "STATS_EXPENSE_READ",
        },
        {
          label: "CA/ROAS",
          name: "ca-roas",
          requiredPermission: "STATS_MARKETING_ROAS_READ",
        },
        {
          label: "KPI Export",
          name: "marketing-kpi-export",
          requiredPermission: "STATS_MARKETING_KPI_READ",
        },
      ],
    };
  },

  computed: {
    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return this.hasPermission(
          this.$store.state.user,
          tab.requiredPermission
        );
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      this.$router.push({ name: this.authorizedTabs[index].name });
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) => tab.name === currentPath
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }

  .tab-content {
    display: none;
  }
}
</style>
